import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Container from '../../styles/Container';
import BrowseMake from '../browse/BrowseMake';
import SearchHeader from '../SearchHeader';
import Footer from '../Footer';

export default class BrowseMakePage extends Component {
	render() {
		var region = this.props.match.params.province ? this.props.match.params.province : false;
		region =  region && region != "KwaZulu-Natal"  ? region.replace('-', ' ') : region
		const city = this.props.match.params.city ? (this.props.match.params.city).replace('-', ' ') : null;
		const origin = typeof window !== 'undefined' ? window.location.origin : 'https://autoforest.co.za';
		const locationLabel = city ? `${city}, ${region || 'South Africa'}` : (region || 'South Africa');
		const breadcrumbItems = [
			{ position: 1, name: 'Home', item: `${origin}/` },
			{ position: 2, name: 'Browse Cars', item: `${origin}/cars` },
		];
		if (region) {
			breadcrumbItems.push({ position: 3, name: `Cars for sale in ${region}`, item: typeof window !== 'undefined' ? window.location.href : '' });
		}
		const collectionPageSchema = {
			'@context': 'https://schema.org',
			'@type': 'CollectionPage',
			name: `Cars for sale in ${locationLabel} | Auto Forest`,
			description: `Find the best deals on cars in ${locationLabel} | Auto Forest`,
			url: typeof window !== 'undefined' ? window.location.href : '',
			isPartOf: { '@type': 'WebSite', name: 'Auto Forest', url: `${origin}/` },
			breadcrumb: {
				'@type': 'BreadcrumbList',
				itemListElement: breadcrumbItems.map(({ position, name, item }) => ({
					'@type': 'ListItem', position, name, item,
				})),
			},
		};
		return (
			<Container>
				<Helmet>
					<meta name="description" content={`Find the best deals on cars in ${region || 'South Africa'} | Auto Forest`} />
					<link rel="canonical" href={window.location.href} />
					<title>Cars for sale in {city !== null ? (city + ', ') : ''} {region || 'South Africa'} | Auto Forest</title>
					<script type="application/ld+json">{JSON.stringify(collectionPageSchema)}</script>
				</Helmet>
				<SearchHeader visible={false} />
				<h2 style={{ textAlign: 'center' }}>Car makes in {city !== null ? (city + ', ') : ''} {region || 'South Africa'}</h2>
				<BrowseMake province={region} city={city} />
				<Footer />
			</Container>
		);
	}
}
